import { render, staticRenderFns } from "./AltaConsultaCredito.vue?vue&type=template&id=5652ba4c"
import script from "./AltaConsultaCredito.vue?vue&type=script&lang=js"
export * from "./AltaConsultaCredito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports